import { createFileRoute } from '@tanstack/react-router'

import { Withdrawal } from '@/pages/withdrawal'

export const Route = createFileRoute('/withdrawal/')({
    component: Withdrawal,
    validateSearch: (search) => {
        return {
            token: search.token ? String(search.token) : undefined,
            phone: search.phone ? String(search.phone) : undefined,
        }
    },
})
